import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/operation.svg'
import _imports_1 from '@/assets/resources.svg'
import _imports_2 from '@/assets/recovery.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f6728db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap" }
const _hoisted_2 = { class: "mod_c" }
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "子账号", -1))
const _hoisted_5 = {
  key: 0,
  class: "mod_c_tbody SuborBox"
}
const _hoisted_6 = { class: "sub_list" }
const _hoisted_7 = { class: "suburl" }
const _hoisted_8 = { id: "sub_url" }
const _hoisted_9 = { class: "sub_btn" }
const _hoisted_10 = { class: "SuborTop" }
const _hoisted_11 = { class: "top_right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "子账号 ：", -1))
const _hoisted_13 = { style: {"margin-top":"16px"} }
const _hoisted_14 = { class: "modalBox" }
const _hoisted_15 = { class: "pop" }
const _hoisted_16 = { class: "section" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_first" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"8px"} }, [
    /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }, "* "),
    /*#__PURE__*/_createTextVNode("账户类型 :")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "section_nub" }, "子账号")
], -1))
const _hoisted_18 = { class: "section_second" }
const _hoisted_19 = { class: "section_ul" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_sub" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }, "* "),
  /*#__PURE__*/_createTextVNode("头像 :")
], -1))
const _hoisted_21 = { class: "section_suba" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_third" }, "上传说明:建议上传尺寸80*80，2M以内", -1))
const _hoisted_23 = { class: "info_name" }
const _hoisted_24 = { class: "section_msg" }
const _hoisted_25 = {
  key: 1,
  class: "infoitem"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_name" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }, "*"),
  /*#__PURE__*/_createTextVNode("验证码 ：")
], -1))
const _hoisted_27 = { class: "top_left" }
const _hoisted_28 = { class: "cache_operate_right" }
const _hoisted_29 = { class: "select_three" }
const _hoisted_30 = { class: "SuborList" }
const _hoisted_31 = ["onClick", "src"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "liveList_out",
  src: _imports_0
}, null, -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "liveList_outs",
  src: _imports_1
}, null, -1))
const _hoisted_36 = { class: "liveList_pagination" }
const _hoisted_37 = { class: "pop" }
const _hoisted_38 = { class: "section" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { style: {"color":"#999999"} }, "不设置将使用默认登录页", -1))
const _hoisted_40 = { class: "section_second" }
const _hoisted_41 = { class: "section_ul" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_sublogin" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }),
  /*#__PURE__*/_createTextVNode("logo :")
], -1))
const _hoisted_43 = { class: "section_suba" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_thirds" }, "上传说明:建议上传尺寸200*200，2M以内", -1))
const _hoisted_45 = { class: "section_second" }
const _hoisted_46 = { class: "section_ul" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_sublogin" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }),
  /*#__PURE__*/_createTextVNode("背景图 :")
], -1))
const _hoisted_48 = { class: "section_suba" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "section_thirds" }, "上传说明:建议上传尺寸1920*1080，2M以内", -1))
const _hoisted_50 = { class: "info_names" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section_msg" }, "*", -1))
const _hoisted_52 = { class: "SuborList" }
const _hoisted_53 = ["onClick", "src"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-top":"-4px"},
  class: "liveList_out",
  src: _imports_2
}, null, -1))
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "liveList_pagination" }

import httpcode from '@/api/home';
import { RollbackOutlined, FormOutlined, SearchOutlined } from '@ant-design/icons-vue';
import CDelModal from '@/components/CDelModal.vue';
import { ref, unref, computed, reactive } from 'vue';
import { message, Input, Modal, Table, Pagination, Button, Tooltip } from 'ant-design-vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import http from '@/api/subordinate';
import CUpload from '@/components/CUpload.vue';
import liveRoom from '@/views/account/Subordinate/liveRoom.vue';
import resources from '@/views/account/Subordinate/resources.vue';
import Crumb from '@/components/Crumb.vue';
import ClipboardJS from 'clipboard';
import { getToken } from '@/plugins/cookie';
import { useHomeStore } from '@/pinia/home';

type Key = ColumnProps['key'];
interface DataType {
  name: string;
  time: string;
  id: string;
  mobile: string;
  email: string;
  pass: string;
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
//图片地址以及id

export default /*#__PURE__*/_defineComponent({
  __name: 'Subordinate',
  setup(__props) {

const homeStore = useHomeStore();
const isNewVersion = computed(() => homeStore.isNewVersion);
const token = getToken();
const aModal = Modal;
const aTable = Table;
const aButton = Button;
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aTooltip = Tooltip;
const everySelect = ref<string>('');
//默认展示子账号列表
const SubaccountList = ref<boolean>(true);
//返回列表
const returnList = () => {
  SubaccountList.value = true;
};
// 复制
const Copylist = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};
// 分页
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 10, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
// 分页器点击事件
const showSize = (current: number) => {
  selectOption(current);
};
const showLoading = ref<boolean>(false);
const loginUrl = ref<string>();
//下级账号列表
const selectOption = (current: number) => {
  let data = {
    keywords: everySelect.value,
    page: current,
    page_num: pageConfigure.pageSize,
  };
  showLoading.value = true;
  http
    .getSubAllocatingList({ params: data })
    .then((res) => {
      pageConfigure.current = res.data.data.current_page;
      pageConfigure.totalSize = res.data.data.total > 0 ? res.data.data.total : 10;
      loginUrl.value = res.data.data.login_url;
      const resData = res.data.data;
      datafol.value = resData.data;
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
      // message.error(res.data.error);
    });
};
selectOption(1);
const pageConfigures = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 10, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
//获取回收站下级列表
const dataBinList = ref<[]>();
const BinList = () => {
  let data = {
    token: token,
    page: pageConfigures.current,
    page_num: pageConfigures.pageSize,
  };
  showLoading.value = true;
  http
    .getSubRecycleBinList({ params: data })
    .then((res) => {
      pageConfigures.current = res.data.data.current_page;
      pageConfigures.totalSize = res.data.data.total > 0 ? res.data.data.total : 10;
      const resData = res.data.data;
      dataBinList.value = resData.data;
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};
//点击列表展示子账号内的直播间
const createGift = ref();
const changeclick = (item: any) => {
  // SubaccountList.value = false;
  createGift.value = item.id;
};
//创建下级账号内容
const liList = ref([
  {
    name: '手机号 :',
    placeholder: '请输入手机号',
    model: '',
    tip: '*',
    id: 0,
  },
  {
    name: '密码 :',
    placeholder: '请输入密码',
    model: '',
    tip: '*',
    id: 1,
  },
  {
    name: '子用户名 :',
    placeholder: '请输入姓名',
    model: '',
    tip: '*',
    id: 2,
  },
  {
    name: '邮箱 :',
    placeholder: '请输入邮箱',
    model: '',
    tip: '*',
    id: 3,
  },
]);
//下级账号弹窗
const createVisible = ref<boolean>(false);
//创建下级账号
const showModal = () => {
  //清除信息
  (imageUrl.value = ''),
    (liList.value[0].model = ''),
    (liList.value[1].model = ''),
    (liList.value[2].model = ''),
    (liList.value[3].model = ''),
    (createVisible.value = true);
};
const handleOk = () => {
  modifySure.value = false;
  disabledStatus.value = false;
  createVisible.value = false;
  LoginVisible.value = false;
  resourcesModal.value = false;
};
//创建子账号按钮
const handleCancellt = () => {
  if (imageUrl.value == '') {
    message.info('头像不能为空');
    return;
  }
  if (liList.value[0].model == '') {
    message.info('手机号不能为空');
    return;
  }
  if (!/^[1][3-9]\d{9}$/.test(liList.value[0].model)) {
    message.info('请填写正确的手机号');
    return;
  }
  if (liList.value[1].model == '') {
    message.info('密码不能为空');
    return;
  }
  if (!/^\d+$|^\d+[.]?\d+$/.test(liList.value[1].model)) {
    message.info('只能输入6位数字');
    return;
  }
  if (liList.value[2].model == '') {
    message.info('姓名不能为空');
    return;
  }
  if (liList.value[3].model == '') {
    message.info('邮箱不能为空');
    return;
  }
  let data = {
    token: token,
    avatar_id: enterpriseID.value, //头像id
    mobile: liList.value[0].model,
    password: liList.value[1].model, //密码
    email: liList.value[3].model,
    name: liList.value[2].model,
  };
  http
    .addAdminSubAccount(data)
    .then((res) => {
      if (res.data.code == 200) {
        selectOption(1);
        message.success(res.data.message);
        createVisible.value = false;
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//修改子账号
const modifySure = ref<boolean>(false);
const modifyID = ref<number>();
const modifyIMGid = ref<number>();
const disabledStatus = ref<boolean>(false);
//修改弹窗
const condition = (item: any) => {
  modifyID.value = item.id;
  modifyIMGid.value = item.image_avatar_id;
  modifySure.value = true;
  createVisible.value = true;
  disabledStatus.value = true;
  imageUrl.value = item.image_avatar_url;
  liList.value[0].model = item.mobile;
  liList.value[1].model = item.password_text; //密码
  liList.value[3].model = item.email;
  liList.value[2].model = item.name;
};
//更改修改状态
const disabClick = () => {
  disabledStatus.value = !disabledStatus.value;
};
//修改手机号填写验证码
const codeStatus = ref<boolean>(false);
const mobilecode = ref<number>();
const changeMobile = (item: any) => {
  if (!item) {
    return;
  }
  // codeStatus.value = true;
};
let isShowcode = ref(true);
let timer: any = ref(0);
const TIME_COUNT = 60;
let count = ref(TIME_COUNT);
const getCode = () => {
  if (!timer.value) {
    count.value = TIME_COUNT;
    isShowcode.value = false;
    timer.value = setInterval(() => {
      if (count.value > 0 && count.value <= TIME_COUNT) {
        count.value--;
      } else {
        isShowcode.value = true;
        clearInterval(timer.value);
        timer.value = 0;
      }
    }, 1000);
  }
  // 获取验证码
  httpcode.sendCaptcha({ type: 0 });
};
const modifyHandleCancellt = () => {
  if (!/^[1][3-9]\d{9}$/.test(liList.value[0].model)) {
    message.info('请填写正确的手机号');
    return;
  }
  if (liList.value[1].model == '') {
    message.info('密码不能为空');
    return;
  }
  if (liList.value[2].model == '') {
    message.info('子用户名不能为空');
    return;
  }
  if (liList.value[3].model == '') {
    message.info('邮箱不能为空');
    return;
  }
  let data = {
    token: token,
    id: modifyID.value, //修改每个子账号的id
    avatar_id: modifyIMGid.value, //头像id
    mobile: liList.value[0].model,
    password: liList.value[1].model, //密码
    email: liList.value[3].model,
    name: liList.value[2].model,
  };
  http
    .setAdminSubAccount(data)
    .then((res) => {
      selectOption(1);
      message.success(res.data.message);
      createVisible.value = false;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//资源弹窗
const resourcesModal = ref<boolean>(false);
//资源分配
const childRef = ref();
const createGifts = ref();
const resourcesClick = (item: any) => {
  createGifts.value = item.id;
  resourcesModal.value = true;
  setTimeout(() => {
    childRef.value.getSubAccountInfo();
    childRef.value.getAccountInfo();
  });
};
//复制
// const copyClick = (item: any) => {
//   let data = {
//     subordinate_id: item.id,
//   };
//   http.getSubAccountUri({ params: data }).then((res) => {
//     message.success(res.data.message);
//   });
// };
//设置登录页
const addStatus = ref<boolean>();
const createdLogin = () => {
  LoginVisible.value = true;
  let data = {
    token: token,
  };
  http.getSubAllocatingLoginPage({ params: data }).then((res) => {
    if (res.data.data == '') {
      addStatus.value = true;
    } else {
      (logoList.value[0].model = res.data.data.login_copyright),
        (logoList.value[1].model = res.data.data.phone),
        (logoList.value[2].model = res.data.data.copyright_info),
        (LogoID.value = res.data.data.logo_id),
        (PcID.value = res.data.data.background_id),
        (logoUrl.value = res.data.data.logo_url),
        (PCUrl.value = res.data.data.backgroun_url),
        (addStatus.value = false);
    }
  });
};
//设置登录页弹窗
const logoList = ref([
  {
    name: '登录标题 :',
    placeholder: '请输入登录标题',
    model: '',
  },
  {
    name: '联系电话 :',
    placeholder: '请输入联系电话',
    model: '',
  },
  {
    name: '版权信息 :',
    placeholder: '请输入版权信息',
    model: '',
  },
]);
const LoginVisible = ref<boolean>(false);
//修改子账号登录配置
const logoSure = () => {
  let data = {
    token: token,
    logo_id: LogoID.value, //logo
    background_id: PcID.value, //背景图
    phone: logoList.value[1].model, //联系电话
    login_copyright: logoList.value[0].model, //登录文案
    copyright_info: logoList.value[2].model, //版权信息
  };
  http
    .setAllocatingLoginPage(data)
    .then(() => {
      LoginVisible.value = false;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//添加子账号登录配置
const AddlogoSure = () => {
  let data = {
    token: token,
    logo_id: LogoID.value, //logo
    background_id: PcID.value, //背景图
    phone: logoList.value[1].model, //联系电话
    login_copyright: logoList.value[0].model, //登录文案
    copyright_info: logoList.value[2].model, //版权信息
  };
  http
    .addSubAllocatingLoginPage(data)
    .then(() => {
      LoginVisible.value = false;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
// 全选状态
const checked_all = ref<boolean>(false);
const setSelectAll = () => {
  let data: any = [];
  datafol.value.map((res) => {
    data.push(res.id);
  });
  if (checked_all.value) {
    onSelectChange([...data]);
  } else {
    onSelectChange([]);
  }
};
//删除按钮
const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  checked_all.value = selectedRowKeys.value.length == datafol.value.length ? true : false;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const openDelModal = () => {
  modal2Visible.value = true;
};
//回收站
// const norecovery = ref<boolean>(true);
const resourcesVisible = ref<boolean>(false);
const recyclebin = () => {
  resourcesVisible.value = true;
  BinList();
  // norecovery.value = !norecovery.value;
};
//还原回收站
const reduction = (item: any) => {
  let data = {
    subordinate_id: item.id,
  };
  http
    .setAccountRestoration(data)
    .then(() => {
      BinList();
      selectOption(1);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
//彻底删除下级账号
const thoroughDelete = (item: any) => {
  let data = {
    subordinate_id: item.id,
  };
  http
    .thoroughDeleteSubAdmin({ params: data })
    .then(() => {
      BinList();
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
// 删除弹框
const modal2Visible = ref<boolean>(false);
const openDelModat = () => {
  modal2Visible.value = !modal2Visible.value;
};
// 删除确定按钮
const removeLiveData = () => {
  let data = {
    token: token,
    id: selectedRowKeys.value.join(','),
  };
  http
    .delAdminSubAccount({ params: data })
    .then((res) => {
      selectOption(1);
      message.success(res.data.message);
      modal2Visible.value = false;
      checked_all.value = false;
      selectedRowKeys.value = [];
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
// 创建下级账号
const columns = [
  {
    title: '头像',
    dataIndex: 'image_avatar_url',
    align: 'center',
    width: '10%',
    slots: {
      customRender: 'image_avatar_url',
    },
  },
  {
    title: '账号',
    dataIndex: 'mobile',
    align: 'center',
    width: '15%',
  },
  {
    title: '创建时间',
    align: 'center',
    dataIndex: 'created_at',
    width: '20%',
  },
  {
    title: '子用户名',
    dataIndex: 'name',
    align: 'center',
    width: '15%',
    slots: {
      customRender: 'name',
    },
  },
  {
    title: '邮箱',
    align: 'center',
    width: '25%',
    dataIndex: 'email',
  },
  {
    title: '操作',
    dataIndex: 'img',
    align: 'center',
    width: '15%',
    slots: {
      customRender: 'img',
    },
  },
];
const Bincolumns = [
  {
    title: '头像',
    dataIndex: 'image_avatar_url',
    align: 'center',
    width: '10%',
    slots: {
      customRender: 'image_avatar_url',
    },
  },
  {
    title: '账号',
    dataIndex: 'mobile',
    align: 'center',
    width: '15%',
  },
  {
    title: '删除时间',
    align: 'center',
    dataIndex: 'deleted_at',
    width: '15%',
  },
  {
    title: '姓名',
    dataIndex: 'name',
    align: 'center',
    width: '15%',
    slots: {
      customRender: 'name',
    },
  },
  {
    title: '邮箱',
    align: 'center',
    width: '15%',
    dataIndex: 'email',
  },
  // {
  //   title: '保存时间',
  //   align: 'center',
  //   width: '15%',
  //   dataIndex: 'email',
  // },
  {
    title: '操作',
    dataIndex: 'img',
    align: 'center',
    width: '15%',
    slots: {
      customRender: 'img',
    },
  },
];
//列表数组
const datafol = ref<DataType[]>([]);
// 上传图片
const fileList = ref([]);
const loading = reactive({
  enterpriseImg: false, //营业执照
  PCImg: false, //pc背景图
  logoImg: false, //logo背景图
});
const imageUrl = ref<string>();
const PCUrl = ref<string>();
const logoUrl = ref<string>();
const enterpriseID = ref<number>();
const PcID = ref<number>();
const LogoID = ref<number>();
const handleChange = (info: FileInfo, keyword: string) => {
  if (info.file.status === 'uploading') {
    loading[keyword] = true;
    return;
  }
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      switch (keyword) {
        case 'enterpriseImg':
          imageUrl.value = info.file?.response?.data.url;
          enterpriseID.value = info.file?.response?.data.id;
          modifyIMGid.value = info.file?.response?.data.id;
          break;
        case 'PCImg':
          PCUrl.value = info.file?.response?.data.url;
          PcID.value = info.file?.response?.data.id;
          break;
        case 'logoImg':
          logoUrl.value = info.file?.response?.data.url;
          LogoID.value = info.file?.response?.data.id;
          break;
      }
    } else {
      message.error(info.file?.response?.error);
    }
    loading[keyword] = false;
  }
  if (info.file.status === 'error') {
    loading[keyword] = false;
    message.error('上传失败');
  }
};
const clearImg = (keyword: string) => {
  switch (keyword) {
    case 'enterpriseImg':
      imageUrl.value = '';
      enterpriseID.value = 0;
      break;
    case 'PCImg':
      PCUrl.value = '';
      PcID.value = 0;
      break;
    case 'logoImg':
      logoUrl.value = '';
      LogoID.value = 0;
      break;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (!SubaccountList.value)
            ? (_openBlock(), _createBlock(_unref(aButton), {
                key: 0,
                onClick: returnList
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(RollbackOutlined))
                ]),
                default: _withCtx(() => [
                  _createTextVNode("返回列表 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (SubaccountList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(" 登录地址："),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(loginUrl.value), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(aButton), {
                    type: "primary",
                    style: {"margin-right":"30px"},
                    onClick: createdLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("配置登录页")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aButton), {
                    type: "primary",
                    class: "btn_levls warrant",
                    "data-clipboard-target": "#sub_url",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (Copylist('.warrant')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("复制")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_unref(aInputSearch), {
                      class: "mod_range_picker_search",
                      value: everySelect.value,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((everySelect).value = $event)),
                      placeholder: "请输入子用户名",
                      onSearch: _cache[2] || (_cache[2] = ($event: any) => (selectOption(1)))
                    }, {
                      enterButton: _withCtx(() => [
                        _createVNode(_unref(SearchOutlined), { color: "#fff" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    _createVNode(_unref(aButton), {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal())),
                      class: "details"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("创建子账号")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(aModal), {
                      visible: createVisible.value,
                      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((createVisible).value = $event)),
                      title: modifySure.value == true ? '修改子账号' : '创建子账号',
                      onCancel: handleOk
                    }, {
                      footer: _withCtx(() => [
                        _createVNode(_unref(aButton), {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleOk()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }),
                        (modifySure.value)
                          ? (_openBlock(), _createBlock(_unref(aButton), {
                              key: 0,
                              type: "primary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (modifyHandleCancellt()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("确定")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_unref(aButton), {
                              key: 1,
                              type: "primary",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (handleCancellt()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("确定")
                              ]),
                              _: 1
                            }))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("li", _hoisted_18, [
                              _createElementVNode("ul", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("li", _hoisted_21, [
                                  _createVNode(CUpload, {
                                    "file-list": fileList.value,
                                    "handle-change": (info) => handleChange(info, 'enterpriseImg'),
                                    loading: loading.enterpriseImg,
                                    "image-name": imageUrl.value,
                                    "click-stop": (info) => clearImg('enterpriseImg'),
                                    class: "ant_upload"
                                  }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                                ])
                              ])
                            ]),
                            _hoisted_22,
                            (modifySure.value)
                              ? (_openBlock(), _createBlock(_unref(FormOutlined), {
                                  key: 0,
                                  class: "edit",
                                  onClick: disabClick
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liList.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "info_item",
                                key: index
                              }, [
                                _createElementVNode("span", _hoisted_23, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(item.tip), 1),
                                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                                ]),
                                _createVNode(_component_a_input, {
                                  class: "establish_top_input",
                                  size: "small",
                                  placeholder: "请输入账号",
                                  value: item.model,
                                  "onUpdate:value": ($event: any) => ((item.model) = $event),
                                  disabled: disabledStatus.value,
                                  onChange: ($event: any) => (changeMobile(item.id == 0))
                                }, null, 8, ["value", "onUpdate:value", "disabled", "onChange"])
                              ]))
                            }), 128)),
                            (codeStatus.value && modifySure.value == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_a_input, {
                                      value: mobilecode.value,
                                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((mobilecode).value = $event)),
                                      placeholder: "请输入验证码",
                                      disabled: disabledStatus.value,
                                      maxlength: 4
                                    }, null, 8, ["value", "disabled"])
                                  ]),
                                  _createElementVNode("span", null, [
                                    _createVNode(_unref(aButton), {
                                      type: "primary",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (getCode()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(isShowcode) ? '获取验证码' : _unref(count)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["visible", "title"])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_a_checkbox, {
                      checked: checked_all.value,
                      "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((checked_all).value = $event)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (setSelectAll())),
                      class: "cache_check"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全选")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_unref(aButton), {
                        disabled: selectedRowKeys.value.length <= 0,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (openDelModal())),
                        class: _normalizeClass(selectedRowKeys.value.length > 0 ? 'select_three_button' : ''),
                        type: "link"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            class: "mod_btn_icon",
                            "icon-class": "del"
                          })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"])
                    ]),
                    _createElementVNode("span", {
                      type: "link",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (recyclebin())),
                      class: "top_primy"
                    }, [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "recovery"
                      }),
                      _createTextVNode(" 回收站")
                    ]),
                    _createVNode(CDelModal, {
                      visible: modal2Visible.value,
                      centered: "",
                      close: openDelModat,
                      ok: removeLiveData
                    }, null, 8, ["visible"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(aTable), {
                  loading: showLoading.value,
                  "row-selection": _unref(rowSelection),
                  columns: columns,
                  "data-source": datafol.value,
                  pagination: false,
                  class: "liveList_w",
                  rowKey: 
          (res) => {
            return res.id;
          }
        ,
                  locale: { emptyText: '暂无数据' }
                }, {
                  image_avatar_url: _withCtx(({ record }) => [
                    _createElementVNode("img", {
                      onClick: ($event: any) => (changeclick(record)),
                      src: record.image_avatar_url,
                      class: "liveList_avatar"
                    }, null, 8, _hoisted_31)
                  ]),
                  img: _withCtx(({ record }) => [
                    _createVNode(_unref(aTooltip), {
                      placement: "top",
                      title: "修改"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (condition(record)),
                          centered: ""
                        }, [
                          _hoisted_33,
                          _createTextVNode(" " + _toDisplayString(record.text), 1)
                        ], 8, _hoisted_32)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(aTooltip), {
                      placement: "top",
                      title: "资源"
                    }, {
                      default: _withCtx(() => [
                        (!_unref(isNewVersion))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (resourcesClick(record)),
                              centered: ""
                            }, [
                              _hoisted_35,
                              _createTextVNode(" " + _toDisplayString(record.text), 1)
                            ], 8, _hoisted_34))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["loading", "row-selection", "data-source", "rowKey"]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_unref(aPagination), {
                    "show-quick-jumper": "",
                    total: pageConfigure.totalSize,
                    current: pageConfigure.current,
                    "onUpdate:current": _cache[14] || (_cache[14] = ($event: any) => ((pageConfigure.current) = $event)),
                    "page-size": pageConfigure.pageSize,
                    "onUpdate:pageSize": _cache[15] || (_cache[15] = ($event: any) => ((pageConfigure.pageSize) = $event)),
                    pageSizeOptions: pageConfigure.options,
                    "show-less-items": "",
                    "show-size-changer": "",
                    onShowSizeChange: showSize,
                    onChange: showSize
                  }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
                ])
              ]),
              _createVNode(_unref(aModal), {
                visible: LoginVisible.value,
                "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((LoginVisible).value = $event)),
                title: "设置登录页",
                onOk: handleOk
              }, {
                footer: _withCtx(() => [
                  _createVNode(_unref(aButton), {
                    class: "mod_modal_btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (handleOk()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  }),
                  (addStatus.value)
                    ? (_openBlock(), _createBlock(_unref(aButton), {
                        key: 0,
                        type: "primary",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (AddlogoSure()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("确定")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(aButton), {
                        key: 1,
                        type: "primary",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (logoSure()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("确定")
                        ]),
                        _: 1
                      }))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("ul", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("li", _hoisted_40, [
                        _createElementVNode("ul", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("li", _hoisted_43, [
                            _createVNode(CUpload, {
                              "file-list": fileList.value,
                              "handle-change": (info) => handleChange(info, 'logoImg'),
                              loading: loading.logoImg,
                              "image-name": logoUrl.value,
                              "click-stop": (info) => clearImg('logoImg'),
                              class: "ant_upload"
                            }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                          ])
                        ])
                      ]),
                      _hoisted_44,
                      _createElementVNode("li", _hoisted_45, [
                        _createElementVNode("ul", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("li", _hoisted_48, [
                            _createVNode(CUpload, {
                              "file-list": fileList.value,
                              "handle-change": (info) => handleChange(info, 'PCImg'),
                              loading: loading.PCImg,
                              "image-name": PCUrl.value,
                              "click-stop": (info) => clearImg('PCImg'),
                              class: "ant_uploads"
                            }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                          ])
                        ])
                      ]),
                      _hoisted_49,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logoList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "info_item",
                          key: index
                        }, [
                          _createElementVNode("span", _hoisted_50, [
                            _hoisted_51,
                            _createTextVNode(" " + _toDisplayString(item.name), 1)
                          ]),
                          _createVNode(_component_a_input, {
                            class: "establish_top_input",
                            size: "small",
                            placeholder: item.placeholder,
                            value: item.model,
                            "onUpdate:value": ($event: any) => ((item.model) = $event)
                          }, null, 8, ["placeholder", "value", "onUpdate:value"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_unref(aModal), {
                visible: resourcesVisible.value,
                "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((resourcesVisible).value = $event)),
                width: "1200px",
                footer: null,
                title: "子账号回收站"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_unref(aTable), {
                      loading: showLoading.value,
                      columns: Bincolumns,
                      "data-source": dataBinList.value,
                      pagination: false,
                      class: "liveList_w",
                      rowKey: 
          (res) => {
            return res.id;
          }
        
                    }, {
                      image_avatar_url: _withCtx(({ record }) => [
                        _createElementVNode("img", {
                          onClick: ($event: any) => (changeclick(record)),
                          src: record.image_avatar_url,
                          class: "liveList_avatar"
                        }, null, 8, _hoisted_53)
                      ]),
                      img: _withCtx(({ record }) => [
                        _createVNode(_unref(aTooltip), {
                          placement: "top",
                          title: "还原"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (reduction(record)),
                              centered: ""
                            }, [
                              _hoisted_55,
                              _createTextVNode(" " + _toDisplayString(record.text), 1)
                            ], 8, _hoisted_54)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(aTooltip), {
                          placement: "top",
                          title: "彻底删除"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              style: {"margin-bottom":"-2px","margin-left":"10px"},
                              onClick: ($event: any) => (thoroughDelete(record)),
                              centered: ""
                            }, [
                              _createVNode(_component_svg_icon, {
                                class: "mod_btn_icon",
                                "icon-class": "del",
                                "font-size": "14px",
                                color: "#1890FF"
                              })
                            ], 8, _hoisted_56)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["loading", "data-source", "rowKey"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_unref(aPagination), {
                        "show-quick-jumper": "",
                        total: pageConfigures.totalSize,
                        current: pageConfigures.current,
                        "onUpdate:current": _cache[20] || (_cache[20] = ($event: any) => ((pageConfigures.current) = $event)),
                        "page-size": pageConfigures.pageSize,
                        "onUpdate:pageSize": _cache[21] || (_cache[21] = ($event: any) => ((pageConfigures.pageSize) = $event)),
                        pageSizeOptions: pageConfigures.options,
                        "show-less-items": "",
                        "show-size-changer": "",
                        onShowSizeChange: showSize,
                        onChange: showSize
                      }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_unref(aModal), {
                visible: resourcesModal.value,
                "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((resourcesModal).value = $event)),
                width: "1200px",
                footer: null,
                title: "资源分配"
              }, {
                default: _withCtx(() => [
                  _createVNode(resources, {
                    data: { id: createGifts.value },
                    ref_key: "childRef",
                    ref: childRef
                  }, null, 8, ["data"])
                ]),
                _: 1
              }, 8, ["visible"])
            ]))
          : (_openBlock(), _createBlock(liveRoom, {
              key: 1,
              data: { id: createGift.value, date: SubaccountList.value }
            }, null, 8, ["data"]))
      ])
    ])
  ]))
}
}

})